module.exports = __webpack_public_path__ + "static/media/fries.64653bf0.jpg";